import { SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const GeneralTermsOfUse = () => {
  const { classes } = useTOCStyles();

  return (
    <>
      <Typography variant="body1" className={classes.paragraph}>
        {`By accessing and using any part of the Web Site, as the case may be, you acknowledge ` +
          `that you have read and understood these Terms and unconditionally agree and accept to ` +
          `be legally bound by and to comply with these Terms and any amendments thereto from time to time.`}
      </Typography>
      <Typography variant="body1" className={classes.paragraph}>
        {`Any non-compliance with these Terms, whether intentionally or otherwise, can lead to significant ` +
          `consequences for the Candidates or Centres involved, including disciplinary action and potential ` +
          `legal repercussions.`}
        <br />
        <br />
      </Typography>
      <SectionHeader title="Consequences for Candidates:" />
      <Typography variant="body1" className={classes.paragraph}>
        {`Candidates may encounter legal action, fines, or criminal charges for violating laws related to computer ` +
          `misuse or unauthorized access to computer systems. Candidates may also face disqualification from the ` +
          `examination, nullification of their registration, or invalidation of their results.  SEAB may bar the ` +
          `Candidates from accessing the Web Site and taking part in future examinations.`}
        <br />
        <br />
      </Typography>
      <SectionHeader title="Consequences for Centres:" />
      <Typography variant="body1" className={classes.paragraph}>
        {`Centres may face legal repercussions, including fines, legal penalties, and potential criminal ` +
          `charges for individuals involved in orchestrating the offense. SEAB may impose sanctions, such as revoking ` +
          `the centre's access, or placing the centre under blacklist publicly. The centre may be held liable for any damages ` +
          `caused by the system overload, including financial losses incurred by SEAB or affected students.`}
        <br />
        <br />
      </Typography>
      <SectionHeader title="General" />
      <ol>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`The Terms of Use may be changed from time to time. Changes will be posted on this ` +
              `page and your continued use of this Web Site will constitute your agreement to the modified ` +
              `Terms of Use.`}
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            We do not guarantee continuous accessibility or uninterrupted operation of the Web Site.
          </Typography>
        </li>
      </ol>
    </>
  );
};
export default GeneralTermsOfUse;
